// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.core

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * This class is responsible for creating instances of classes based on their name or hash and is mainly used for deserialization of saved data.
 *
 * C++ `JPH::Factory`.
 */
class Factory internal constructor(internal val factoryHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    constructor() : this(JphFactory_create(), owned = true)

    override fun close() =
        closeOnce { JphFactory_destroy(factoryHandle) }

    /** Create an object */
    fun createObject(name: String?): NativePointer =
        interopScope { JphFactory_CreateObject(factoryHandle, toInterop(name)) }

    /** Unregisters all types */
    fun clear() =
        JphFactory_Clear(factoryHandle)
}
